import React, { useState, useEffect } from "react";
import PrintAppFind from "src/print-configuration/PrintAppFind";
import useConfigration from "../../hooks/useConfigration";

function PrintConfig() {
  const { newPrinterList, setDefaultPrinters, selectedPrinters: initialSelectedPrinters, handlePrint } = PrintAppFind();

  const [selectedPrinters, setSelectedPrinters] = useState<string[]>([]);
  const [appPrinterEnabled, setAppPrinterEnabled] = useState<boolean>(false);
  const { config, patchConfig } = useConfigration();
  const toBoolean = (value: any) => value === true || value === "true";

  // ✅ Auto check when printers are loaded
  useEffect(() => {
    if (initialSelectedPrinters?.length) {
      setSelectedPrinters(initialSelectedPrinters);
    }
  }, [initialSelectedPrinters]);

  useEffect(() => {
    if (toBoolean(config?.appPrinterEnabled) === true) {
      setAppPrinterEnabled(true);
    } else {
      setAppPrinterEnabled(false);
    }
  }, [config?.appPrinterEnabled]);

  const handleCheckboxChange = (printerName: string) => {
    setSelectedPrinters((prev) => (prev.includes(printerName) ? prev.filter((p) => p !== printerName) : [...prev, printerName]));
  };

  const handleUpdate = () => {
    setDefaultPrinters(selectedPrinters);
    if (toBoolean(config?.appPrinterEnabled) === false) {
      patchConfig({ appPrinterEnabled: appPrinterEnabled });
    }
  };

  const printerName = newPrinterList.map((printer) => printer);

  const DisableTest = selectedPrinters.length === 0 && !selectedPrinters.includes(printerName.map((printer) => printer)[0]);

  return (
    <div className='w-full h-fit flex justify-center items-center p-4' id='profile-theme-page'>
      <div className='w-full lg:w-1/2 border border-blue-100 shadow-xl rounded-2xl p-4' id='btn-my-profile'>
        <h2 className='text-xl font-bold mb-4 w-full text-center'>Printer Configuration</h2>
        <div className='w-full'>
          <label className='flex items-center space-x-3 cursor-pointer pl-2'>
            <input type='checkbox' checked={appPrinterEnabled} onChange={() => setAppPrinterEnabled(!appPrinterEnabled)} className='w-4 h-4' />
            <span className='text-lg font-semibold'>Enable App Printer</span>
          </label>
        </div>
        <div className='w-full p-4 bg-white rounded-lg shadow-md mt-6 flex flex-col items-center relative'>
          {/* Blur Overlay */}
          {!appPrinterEnabled && <div className='absolute inset-0 bg-white/60 backdrop-blur-sm z-20 rounded-lg' />}

          <div className='w-full lg:w-1/2 p-4 border border-gray-200 rounded-lg shadow-sm space-y-3'>
            <h1 className='text-lg font-semibold'>Printer List</h1>

            {newPrinterList?.map((item: string, index: number) => (
              <label key={index} className='flex items-center space-x-3 cursor-pointer pl-2'>
                <input type='checkbox' checked={selectedPrinters.includes(item)} onChange={() => handleCheckboxChange(item)} className='w-4 h-4' />
                <span>{item}</span>
              </label>
            ))}
          </div>

          <div className='w-full flex justify-center gap-4 mt-4'>
            <button onClick={handleUpdate} className='px-6 py-2 bg-blue-600 text-white rounded-md shadow hover:bg-blue-700'>
              Update
            </button>
          </div>
        </div>
        {!appPrinterEnabled && (
          <div className='w-full flex justify-center gap-4 mt-4'>
            <button
              onClick={() => patchConfig({ appPrinterEnabled: appPrinterEnabled })}
              className='px-6 py-2 bg-blue-600 text-white rounded-md shadow hover:bg-blue-700'
            >
              Update
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default PrintConfig;
